module.exports = __webpack_public_path__ + "img/ventilation.e6c17238.svg";